import { render, staticRenderFns } from "./ModalSiloImg.vue?vue&type=template&id=5fe12144&"
import script from "./ModalSiloImg.vue?vue&type=script&lang=js&"
export * from "./ModalSiloImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports